import * as CryptoJS from 'crypto-js';
import Data from "../../Data/Data.json"

export class Crypter{

  private static _key: string = Data.SecretKey.AesKey;
  private static _iv: string = Data.SecretKey.AesIv;

  public static encrypt(message: string){
    let key : CryptoJS.lib.WordArray  = CryptoJS.enc.Base64.parse(Crypter._key);
    let iv : CryptoJS.lib.WordArray = CryptoJS.enc.Base64.parse(Crypter._iv);
    let ciphertext = CryptoJS.AES.encrypt(message, key, {iv: iv}).toString();
    return ciphertext;
  }

  public static decrypt(message: string){
    try {
      let key : CryptoJS.lib.WordArray  = CryptoJS.enc.Base64.parse(Crypter._key);
      let iv : CryptoJS.lib.WordArray  = CryptoJS.enc.Base64.parse(Crypter._iv);
      let decryptedData = CryptoJS.AES.decrypt(message, key, {
        iv: iv
      });
      const plain = decryptedData.toString( CryptoJS.enc.Utf8);
      if (!plain) {
        throw new Error('Résultat du déchiffrement vide (clé invalide ou données corrompues)');
      }
      return plain;
    } catch (err: any) {
      const preview = typeof message === 'string' ? message.substring(0, 120) : String(message);
      console.error('[DECRYPT ERROR] Impossible de déchiffrer la réponse.', {
        preview,
        inputType: typeof message,
        inputLength: message?.length,
        cause: err?.message,
      });
      throw new Error(`Déchiffrement échoué. Le serveur a probablement renvoyé du non-chiffré (HTML/JSON d'erreur) ou la clé est incorrecte. Aperçu reçu: ${preview}...`);
    }
  }
}